import { render, staticRenderFns } from "./CustomServiceManage.vue?vue&type=template&id=c924fd32"
import script from "./CustomServiceManage.vue?vue&type=script&lang=js"
export * from "./CustomServiceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports